// extracted by mini-css-extract-plugin
module.exports = {"btn_orange":"BtnReadOnline_btn_orange__Y1PIc","btn_orange_mobWide":"BtnReadOnline_btn_orange_mobWide__mLXvM"};